import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
  standalone: false,
  name: 'sanitizeGoogle',
})
export class SanitizeGooglePipe implements PipeTransform {
  constructor(private _sanitizer: DomSanitizer) {}

  transform(url: string): SafeResourceUrl {
    // eslint-disable-next-line
    return this._sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
